import React from "react";
import "./footer.css";
import { AiFillPhone } from "react-icons/ai";

const ContactCard = ({ location, address, phone, email }) => {
  const getFlagUrl = (loc) => {
    const trimmedLoc = loc.trim();
    const codeMap = {
      "India": "/assets/gif/Untitled design.gif",
      "Canada": "/assets/gif/ca.gif",
      "Australia": "/assets/gif/au flag.gif",
      "United States": "/assets/gif/us flag design.gif"
    };
    return codeMap[trimmedLoc] || null;
  };

  const flagUrl = getFlagUrl(location);

  return (
    <div className="contact-card">
      <h4>
        {flagUrl && <img src={flagUrl} alt="" className="country-flag" />}
        {location.trim()}
      </h4>
      <p>{address}</p>
      <p><AiFillPhone style={{ marginRight: '8px', verticalAlign: 'middle', transform: 'scaleX(-1)' }} />{phone}</p>
    </div>
  );
};

export default ContactCard;
